import { render, staticRenderFns } from "./LicenseIcon.vue?vue&type=template&id=684f5dd0&"
import script from "./LicenseIcon.vue?vue&type=script&lang=js&"
export * from "./LicenseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports